import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const certificationSchemesApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'certificationSchemesApi',
  endpoints: (builder) => ({
    getCertificationSchemes: builder.query<CertificationSchemesItem[], CertificationSchemesInput>({
      query: ({ trts, docs }) => ({
        url: `certification/v4.0/schemes/`,
        params: { trts, docs },
      }),
    }),
  }),
})

export const certificationSchemesSlice = createSlice({
  name: 'certificationSchemes',
  initialState: {
    certificationSchemes: {} as Record<string, CertificationSchemesItem[]>,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      certificationSchemesApi.endpoints.getCertificationSchemes.matchFulfilled,
      (state, { payload, meta }) => {
        const { trts, docs } = meta.arg.originalArgs;
        const key = [ trts, docs ].join(':');

        state.certificationSchemes[key] = payload
      }
    );
  },
})

export const { useLazyGetCertificationSchemesQuery } = certificationSchemesApi

export const useCertificationSchemes = ({ trts, docs }: CertificationSchemesInput) => {
  const key = [ trts, docs ].join(':');

  return useSelector(({ certificationSchemes }: ReturnType<typeof rootReducer>) => certificationSchemes.certificationSchemes[key])
}
